import { useEffect, useRef, useState } from "react";

import { Portal } from "@blueprintjs/core";
import Confetti from "react-confetti";

import { Box } from "@/components/layout/flexbox";

interface ConfettiOverlayProps {
  recycle?: boolean;
  onConfettiComplete?: () => void;
}

export function ConfettiOverlay({
  recycle,
  onConfettiComplete,
}: ConfettiOverlayProps) {
  const [marginTop, setMarginTop] = useState(0);
  const domRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setTimeout(() => {
      const { top } = domRef.current?.getBoundingClientRect() ?? { top: 0 };
      setMarginTop(-top);
    }, 0);
  }, []);

  return (
    <Portal>
      <Box ref={domRef} mt={marginTop} style={{ position: "relative" }}>
        <Confetti recycle={recycle} onConfettiComplete={onConfettiComplete} />
      </Box>
    </Portal>
  );
}
